module.exports = __webpack_public_path__ + "img/Background_dark.9fb3e114.png";